const t = "_container_6n33d_1", o = "_entityColor1_6n33d_17", n = "_disabled_6n33d_20", i = "_entityColor2_6n33d_23", r = "_entityColor3_6n33d_29", _ = "_entityColor4_6n33d_35", e = "_entityColor5_6n33d_41", l = "_entityColor6_6n33d_47", y = "_entityColor7_6n33d_53", C = "_entityColor8_6n33d_59", s = "_entityColor1Light_6n33d_65", c = "_entityColor2Light_6n33d_71", a = "_entityColor3Light_6n33d_77", d = "_entityColor4Light_6n33d_83", h = "_entityColor5Light_6n33d_89", k = "_entityColor6Light_6n33d_95", g = "_entityColor7Light_6n33d_101", D = "_entityColor8Light_6n33d_107", L = "_entityColor1Dark_6n33d_113", b = "_entityColor2Dark_6n33d_119", u = "_entityColor3Dark_6n33d_125", z = "_entityColor4Dark_6n33d_131", f = "_entityColor5Dark_6n33d_137", p = "_entityColor6Dark_6n33d_143", x = "_entityColor7Dark_6n33d_149", j = "_entityColor8Dark_6n33d_155", m = "_horizontal_6n33d_161", q = {
  container: t,
  "thickness-thin": "_thickness-thin_6n33d_5",
  "thickness-regular": "_thickness-regular_6n33d_9",
  "thickness-thick": "_thickness-thick_6n33d_13",
  entityColor1: o,
  disabled: n,
  entityColor2: i,
  entityColor3: r,
  entityColor4: _,
  entityColor5: e,
  entityColor6: l,
  entityColor7: y,
  entityColor8: C,
  entityColor1Light: s,
  entityColor2Light: c,
  entityColor3Light: a,
  entityColor4Light: d,
  entityColor5Light: h,
  entityColor6Light: k,
  entityColor7Light: g,
  entityColor8Light: D,
  entityColor1Dark: L,
  entityColor2Dark: b,
  entityColor3Dark: u,
  entityColor4Dark: z,
  entityColor5Dark: f,
  entityColor6Dark: p,
  entityColor7Dark: x,
  entityColor8Dark: j,
  horizontal: m
};
export {
  t as container,
  q as default,
  n as disabled,
  o as entityColor1,
  L as entityColor1Dark,
  s as entityColor1Light,
  i as entityColor2,
  b as entityColor2Dark,
  c as entityColor2Light,
  r as entityColor3,
  u as entityColor3Dark,
  a as entityColor3Light,
  _ as entityColor4,
  z as entityColor4Dark,
  d as entityColor4Light,
  e as entityColor5,
  f as entityColor5Dark,
  h as entityColor5Light,
  l as entityColor6,
  p as entityColor6Dark,
  k as entityColor6Light,
  y as entityColor7,
  x as entityColor7Dark,
  g as entityColor7Light,
  C as entityColor8,
  j as entityColor8Dark,
  D as entityColor8Light,
  m as horizontal
};
//# sourceMappingURL=index.es654.js.map
